import _ from 'lodash';
import React, {Fragment, PureComponent} from 'react';
import PropTypes from 'prop-types';
import {withStyles} from "@material-ui/core/styles";
import FormCheckbox from "../form/FormCheckbox";
import CompanyDepartmentContainer from '../../containers/CompanyDepartment';
import Grid from "@material-ui/core/Grid";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import SectionHeader from "../SectionHeader";


const styles = () => {
	return {
		fetching : {
			fontStyle : 'italic',
			padding : '10px 0px',
			color : '#777',
		},
	};
};

class CompanyDepartmentPicker extends PureComponent {
	componentDidMount () {
		if (_.isEmpty(this.props.companyDepartments)) {
			this.props.searchCompanyDepartments();
		}
	}

	render () {
		const {
			label, value, path, onChange, disabled,
			error, helpText, classes,
			companyDepartments
		} = this.props;


		const hasError = !!error;

		if (_.isEmpty(companyDepartments)) {
			return (<div className={classes.fetching}>Fetching departments...</div>);
		}

		const options = _.sortBy(companyDepartments, 'displayName').map(companyDepartment => {
			const { companyDepartmentId, displayName } = companyDepartment;
			return {
				companyDepartmentId,
				displayName
			};
		});

		return (<Fragment>
				<SectionHeader label={label} gridProps={{xs : 12 }} />
				<Grid item xs={12}>
					<FormControl fullWidth={true} error={hasError} disabled={disabled} margin={'dense'}>
						<Grid container spacing={2}>
							{options.map(({companyDepartmentId, displayName}) => {
								const childPath = `${path}.${companyDepartmentId}`;
								return (
									<Grid item xs={12} sm={6} key={childPath}>
										<FormCheckbox
											path={childPath}
											label={displayName}
											value={companyDepartmentId}
											checked={!!value[companyDepartmentId]}
											onChange={onChange}
										/>
									</Grid>
								);
							})}
						</Grid>
						{hasError && <FormHelperText>{error}</FormHelperText>}
						{(helpText && !hasError) && <FormHelperText>{helpText}</FormHelperText>}
					</FormControl>
				</Grid>
			</Fragment>
		);
	}
}

CompanyDepartmentPicker.propTypes = {
	label : PropTypes.string,
	value :	PropTypes.object.isRequired,
	path: PropTypes.string.isRequired,
	onChange : PropTypes.func.isRequired,
	error : PropTypes.string,

	classes : PropTypes.object,
	md : PropTypes.number,
	helpText : PropTypes.string,

	dataDumpMap : PropTypes.object,

	searchCompanyDepartments: PropTypes.func,
	companyDepartments : PropTypes.array,
};

CompanyDepartmentPicker.defaultProps =  {
	md : 12,
	label : 'Company Departments',
};

export default _.flow([
	withStyles(styles),
	CompanyDepartmentContainer,
])(CompanyDepartmentPicker);
